import React, { useMemo, useState } from 'react';
import { ShippingBanner } from '../components/ShippingBanner';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { FilterBar, FilterState } from '../components/shop/FilterBar';
import { ProductCard, Product } from '../components/shop/ProductCard';
import { Pagination } from '../components/shop/Pagination';
// Product images from Christiana's collection
const IMAGES = {
  blackPeplum: 'https://cdn.magicpatterns.com/uploads/k3nbovxYYDH3962AQgD28u/photo_2026-02-04_04-57-03.jpg',
  brownPleated: 'https://cdn.magicpatterns.com/uploads/dyohvQLDScUhskTJ884wYi/photo_2026-02-04_04-57-01.jpg',
  purpleFringe: 'https://cdn.magicpatterns.com/uploads/rrAJzJnT1RaD9iNVi3fG4e/photo_2026-02-04_04-57-00.jpg',
  tealSuit: 'https://cdn.magicpatterns.com/uploads/3hrnMEGcTHukVuERpb86Hi/photo_2026-02-04_04-57-05.jpg',
  greenMaxi: 'https://cdn.magicpatterns.com/uploads/n3jybvjJ42ADZp6V5BmhiN/photo_2026-02-04_04-57-04.jpg',
  goldPleated: 'https://cdn.magicpatterns.com/uploads/ksWTzFirUa358KYJesShzR/photo_2026-02-04_04-56-59.jpg',
  blackEmbroidered: 'https://cdn.magicpatterns.com/uploads/8Pmu6fAwDDrQ92G1L4HjJg/photo_2026-02-04_04-56-58.jpg',
  emeraldSuit: 'https://cdn.magicpatterns.com/uploads/wYFN1VGG9zCp3b6QMLCMkr/photo_2026-02-04_04-56-56.jpg'
};
const allProducts: Product[] = [
// Page 1 - 9 products
{
  id: 1,
  name: 'Black Peplum & Sequin Skirt Set',
  price: '$185.00',
  category: 'Dresses',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.blackPeplum,
  badge: 'New'
}, {
  id: 2,
  name: 'Brown Pleated Midi Dress',
  price: '$145.00',
  category: 'Dresses',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.brownPleated
}, {
  id: 3,
  name: 'Purple Fringe Embellished Dress',
  price: '$210.00',
  category: 'Dresses',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.purpleFringe
}, {
  id: 4,
  name: 'Teal Crystal Embellished Suit',
  price: '$195.00',
  category: 'Tops',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.tealSuit,
  badge: 'New'
}, {
  id: 5,
  name: 'Green Embroidered Maxi Dress',
  price: '$175.00',
  category: 'Dresses',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.greenMaxi
}, {
  id: 6,
  name: 'Gold Puff Sleeve Pleated Gown',
  price: '$225.00',
  category: 'Dresses',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.goldPleated,
  badge: 'New'
}, {
  id: 7,
  name: 'Black & Gold Embroidered Kaftan',
  price: '$245.00',
  category: 'Dresses',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.blackEmbroidered
}, {
  id: 8,
  name: 'Emerald Crystal Belted Suit',
  price: '$195.00',
  category: 'Tops',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.emeraldSuit
}, {
  id: 9,
  name: 'Midnight Sequin Evening Gown',
  price: '$265.00',
  category: 'Dresses',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.blackPeplum
},
// Page 2 - 9 more products
{
  id: 10,
  name: 'Champagne Satin Pleated Set',
  price: '$155.00',
  category: 'Dresses',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.brownPleated,
  badge: 'Sale'
}, {
  id: 11,
  name: 'Royal Purple Beaded Kaftan',
  price: '$235.00',
  category: 'Dresses',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.purpleFringe
}, {
  id: 12,
  name: 'Ocean Teal Power Suit',
  price: '$215.00',
  category: 'Tops',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.tealSuit
}, {
  id: 13,
  name: 'Forest Green Flowing Gown',
  price: '$189.00',
  category: 'Dresses',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.greenMaxi
}, {
  id: 14,
  name: 'Sunrise Gold Maxi Dress',
  price: '$199.00',
  category: 'Dresses',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.goldPleated
}, {
  id: 15,
  name: 'Onyx Embroidered Evening Set',
  price: '$275.00',
  category: 'Dresses',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.blackEmbroidered,
  badge: 'New'
}, {
  id: 16,
  name: 'Jade Crystal Palazzo Set',
  price: '$205.00',
  category: 'Tops',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.emeraldSuit
}, {
  id: 17,
  name: 'Noir Peplum Cocktail Dress',
  price: '$169.00',
  category: 'Dresses',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.blackPeplum,
  badge: 'Sale'
}, {
  id: 18,
  name: 'Mocha Pleated Wrap Dress',
  price: '$159.00',
  category: 'Dresses',
  color: 'bg-[#F5E6D3]',
  image: IMAGES.brownPleated
}];
const ITEMS_PER_PAGE = 9;
export function ShopPage() {
  const [filters, setFilters] = useState<FilterState>({
    category: 'All',
    size: '',
    sort: 'Newest'
  });
  const [currentPage, setCurrentPage] = useState(1);
  const filteredProducts = useMemo(() => {
    let result = [...allProducts];
    if (filters.category !== 'All') {
      result = result.filter(p => p.category === filters.category);
    }
    if (filters.sort === 'Price: Low to High') {
      result.sort((a, b) => parseFloat(a.price.replace('$', '')) - parseFloat(b.price.replace('$', '')));
    } else if (filters.sort === 'Price: High to Low') {
      result.sort((a, b) => parseFloat(b.price.replace('$', '')) - parseFloat(a.price.replace('$', '')));
    }
    return result;
  }, [filters.category, filters.sort]);
  const totalPages = Math.ceil(filteredProducts.length / ITEMS_PER_PAGE);
  const handleFilterChange = (newFilters: FilterState) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };
  const paginatedProducts = useMemo(() => {
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    return filteredProducts.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  }, [filteredProducts, currentPage]);
  const startItem = (currentPage - 1) * ITEMS_PER_PAGE + 1;
  const endItem = Math.min(currentPage * ITEMS_PER_PAGE, filteredProducts.length);
  return <div className="min-h-screen flex flex-col bg-[#FDF8F3]" data-id="element-997">
      <ShippingBanner data-id="element-998" />
      <Navbar data-id="element-999" />

      <main className="flex-grow" data-id="element-1000">
        <div className="text-center pt-16 pb-12 px-4" data-id="element-1001">
          <h1 className="text-5xl md:text-6xl font-['Playfair_Display'] text-[#5C3D2E] mb-3" data-id="element-1002">
            Browse Our Collection
          </h1>
          <div className="w-14 h-[2px] bg-[#D4A853] mx-auto mb-6" data-id="element-1003"></div>
          <p className="text-[#6B5B4F] font-['Raleway'] max-w-xl mx-auto text-lg leading-relaxed" data-id="element-1004">
            Discover timeless pieces designed for the modern African woman
          </p>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24" data-id="element-1005">
          <FilterBar filters={filters} setFilters={handleFilterChange} data-id="element-1006" />

          <div className="flex justify-between items-center mb-8" data-id="element-1007">
            <p className="text-base text-[#6B5B4F] font-['Raleway']" data-id="element-1008">
              Showing{' '}
              <span className="text-[#5C3D2E] font-medium" data-id="element-1009">
                {startItem}–{endItem}
              </span>{' '}
              of{' '}
              <span className="text-[#5C3D2E] font-medium" data-id="element-1010">
                {filteredProducts.length}
              </span>{' '}
              products
            </p>
          </div>

          {paginatedProducts.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-10 lg:gap-x-8 lg:gap-y-12" data-id="element-1011">
              {paginatedProducts.map(product => <ProductCard key={product.id} product={product} data-id="element-1012" />)}
            </div> : <div className="text-center py-16" data-id="element-1013">
              <p className="text-[#6B5B4F] font-['Raleway'] mb-2" data-id="element-1014">
                No products found matching your filters.
              </p>
              <button onClick={() => handleFilterChange({
            category: 'All',
            size: '',
            sort: 'Newest'
          })} className="text-base text-[#D4A853] hover:text-[#B8923F] font-['Raleway'] underline underline-offset-2 transition-colors" data-id="element-1015">
                Clear all filters
              </button>
            </div>}

          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} data-id="element-1016" />
        </div>
      </main>

      <Footer data-id="element-1017" />
    </div>;
}